"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Link = function Link() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 7.178v.378c0 1.184-.471 2.32-1.311 3.155l-3.134 3.145a1.5 1.5 0 01-2.11 0l-.112-.123a.555.555 0 010-.777l3.822-3.823c.408-.423.632-.99.623-1.577v-.378c0-.592-.236-1.16-.656-1.578l-.722-.722a2.222 2.222 0 00-1.578-.656h-.378c-.592 0-1.16.236-1.577.656l-3.823 3.789a.555.555 0 01-.777 0l-.123-.122a1.5 1.5 0 010-2.112l3.145-3.155A4.445 4.445 0 0116.444 2h.378c1.18 0 2.31.467 3.144 1.3l.734.733A4.445 4.445 0 0122 7.178zM8.278 14.156l5.877-5.878a.555.555 0 01.79 0l.777.778a.555.555 0 010 .789l-5.878 5.877a.556.556 0 01-.789 0l-.777-.777a.556.556 0 010-.79zm5.455 1.177a.555.555 0 00-.778 0l-3.81 3.79c-.42.422-.993.658-1.59.655h-.377c-.593 0-1.16-.236-1.578-.656l-.722-.722a2.222 2.222 0 01-.656-1.578v-.377c0-.593.236-1.16.656-1.578l3.8-3.823a.555.555 0 000-.777l-.123-.122a1.5 1.5 0 00-2.11 0L3.31 13.289A4.444 4.444 0 002 16.445v.388a4.444 4.444 0 001.3 3.134l.733.733A4.445 4.445 0 007.178 22h.378a4.445 4.445 0 003.133-1.267l3.166-3.166a1.5 1.5 0 000-2.111l-.122-.123z",
    clipRule: "evenodd"
  });
};

exports.Link = Link;